<template>
  <div class="py-6 px-4">
    <h2 class="text-xl font-semibold text-gray-800 mb-6">
      {{ adData?.mode === 'edit' ? 'Modifier la Publicité' : 'Nouvelle Publicité' }}
    </h2>

    <form @submit.prevent ref="form" class="space-y-6">
      <div class="rounded-2xl border border-gray-200 bg-white p-6 space-y-4">
        <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">
          Image de la publicité
        </h3>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Image *
          </label>
          <FileUploader
            placeHolder="Choisir une image pour la publicité"
            :acceptedFilesTypes="['image/*']"
            @onFileChangedV2="handleImageUpload"
            :fileId="ad.picture"
          />
          <div v-if="ad.picture" class="mt-3">
            <img
              :src="ad.picture"
              alt="Aperçu"
              class="h-32 rounded-lg object-cover"
            />
          </div>
        </div>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-white p-6 space-y-4">
        <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">
          Informations de la publicité
        </h3>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Titre *
          </label>
          <input
            required
            type="text"
            v-model="ad.title"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            placeholder="Titre de la publicité"
          />
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            v-model="ad.description"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            placeholder="Description optionnelle"
            rows="3"
          ></textarea>
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Audience cible *
          </label>
          <select
            required
            v-model="ad.targetAudience"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
          >
            <option value="restaurant">Restaurant</option>
            <option value="client">Client</option>
            <!-- <option value="delivery">Livreur</option> -->
            <option value="all">Tous</option>
          </select>
        </div>

        <div class="grid grid-cols-2 gap-4" v-if="false">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Date de début *
            </label>
            <input
              required
              type="date"
              v-model="ad.startDate"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            />
          </div>
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Date de fin *
            </label>
            <input
              required
              type="date"
              v-model="ad.endDate"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            />
          </div>
        </div>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-white p-6 space-y-4">
        <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">
          Action au clic
        </h3>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Type d'action *
          </label>
          <select
            required
            v-model="ad.actionType"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
          >
            <option value="external">Lien externe</option>
            <option value="internal">Page interne</option>
            <option value="coupon">Coupon</option>
            <option value="restaurant">Restaurant</option>
            <option value="dish">Plat</option>
            <option value="feature">Fonctionnalité</option>
          </select>
        </div>

        <div v-if="ad.actionType === 'external'">
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            URL externe *
          </label>
          <input
            required
            type="url"
            v-model="ad.linkUrl"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
            placeholder="Ex: https://monrapidoo.com"
          />
        </div>

        <div v-if="ad.actionType === 'internal'">
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Page interne *
          </label>
          <select
            required
            v-model="ad.internalPage"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
          >
            <option value="/orders">Commandes</option>
            <option value="/restaurants">Restaurants</option>
            <option value="/profile">Profil</option>
            <option value="/favorites">Favoris</option>
            <option value="/cart">Panier</option>
          </select>
        </div>

        <div v-if="ad.actionType === 'coupon'">
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Coupon *
          </label>
          <select
            required
            v-model="ad.coupon"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
          >
            <option v-for="coupon in coupons" :key="coupon.id" :value="coupon">
              {{ coupon.code }} - {{ coupon.title }}
            </option>
          </select>
        </div>

        <div v-if="ad.actionType === 'restaurant'">
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Restaurant *
          </label>
          <select
            required
            v-model="ad.restaurantId"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
          >
            <option v-for="restaurant in restaurants" :key="restaurant.id" :value="restaurant.id">
              {{ restaurant.storeName || restaurant.name }}
            </option>
          </select>
        </div>

        <div v-if="ad.actionType === 'dish'">
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Plat *
          </label>
          <select
            required
            v-model="ad.dishId"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
          >
            <option v-for="dish in dishes" :key="dish.id" :value="dish.id">
              {{ dish.title }} ({{ dish.storeName }})
            </option>
          </select>
        </div>

        <div v-if="ad.actionType === 'feature'">
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Fonctionnalité *
          </label>
          <select
            required
            v-model="ad.feature"
            class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs focus:border-primary-500 focus:outline-hidden focus:ring-3 focus:ring-primary-500/10"
          >
            <option value="openCart">Ouvrir le panier</option>
            <option value="openFavorites">Ouvrir les favoris</option>
            <option value="openOrders">Ouvrir les commandes</option>
          </select>
        </div>
      </div>

      <button class="hidden"></button>
    </form>

    <div class="flex gap-3 !mt-8">
      <button
        type="button"
        @click="$emit('cancel')"
        class="flex-1 rounded-lg border border-gray-300 bg-white px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
      >
        Annuler
      </button>
      <button
        type="button"
        @click="startSave"
        class="flex-1 rounded-lg bg-primary px-6 py-3 text-sm font-medium text-white hover:bg-primary/90"
      >
        {{ adData?.mode === 'edit' ? 'Mettre à jour' : 'Créer' }} la publicité
      </button>
    </div>

    <ActionTrigger
      dataKey="saveAd"
      ref="saveAdTrigger"
      @success="onSuccess"
      @failed="onError"
    />
  </div>
</template>

<script setup>
import { reactive, ref, watch, computed } from 'vue'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import Events from '@/events/events'
import { EVENTS } from '@/shared/constants/commons'
import FileUploader from '@/presentation/components/input/FileUploader.vue'

const props = defineProps({
  adData: { type: Object, default: () => ({}) },
  availableRestaurants: { type: Array, default: () => [] },
  availableCoupons: { type: Array, default: () => [] },
  availableDishes: { type: Array, default: () => [] },
})

const emit = defineEmits(['saved', 'cancel'])

const saveAdTrigger = ref(null)
const form = ref(null)

const restaurants = computed(() => props.availableRestaurants || [])
const coupons = computed(() => props.availableCoupons || [])
const dishes = computed(() => props.availableDishes || [])

const ad = reactive({
  id: null,
  title: '',
  description: '',
  picture: '',
  targetAudience: 'restaurant',
  actionType: 'external',
  linkUrl: '',
  internalPage: '',
  coupon: null,
  restaurantId: '',
  feature: '',
  dishId: '',
  startDate: new Date().toISOString().substring(0, 10),
  endDate: (() => {
    const d = new Date()
    d.setFullYear(d.getFullYear() + 1)
    return d.toISOString().substring(0, 10)
  })(),
  order: null,
})

watch(
  () => props.adData,
  val => {
    if (val && Object.keys(val).length && val.mode !== 'create') {
      Object.assign(ad, {
        id: val.id || null,
        title: val.title || '',
        description: val.description || '',
        picture: val.picture || val.imageUrl || '',
        targetAudience: val.targetAudience || 'restaurant',
        actionType: val.actionType || 'external',
        linkUrl: val.linkUrl || val.url || '',
        internalPage: val.internalPage || '',
        coupon: val.coupon || null,
        restaurantId: val.restaurantId || '',
        feature: val.feature || '',
        dishId: val.dishId || '',
        startDate: val.startDate ? val.startDate.substring(0, 10) : '',
        endDate: val.endDate ? val.endDate.substring(0, 10) : '',
        order: val.order ?? null,
      })
    }
  },
  { immediate: true }
)

function startSave() {
  const isValid = form.value.checkValidity()
  if (!isValid) {
    form.value.reportValidity()
    return
  }

  saveAd()
}

function saveAd() {
  saveAdTrigger.value.trigger({
    action: props.adData?.mode === 'edit' ? 'update' : 'create',
    ad: { ...ad },
  })
}

function onSuccess() {
  emit('saved')
}

function onError(err) {
  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: "Erreur d'enregistrement",
    body: err.result?.message || 'Erreur inconnue',
  })
}

function handleImageUpload(fileData) {
  ad.picture = fileData.url
}
</script>